import { AssignedDriver } from './types';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Chip } from '@mui/material';

import styles from './ButtonContent.module.css';

interface DriverButtonContentProps {
	assigned?: AssignedDriver | null;
	/** Flag indicating that the input should not display vehicle information */
	disableVehicleInfo?: boolean;
}

export default function ButtonContent({ assigned, disableVehicleInfo }: DriverButtonContentProps) {
	if (!assigned?.driver) {
		return <span>No Driver Assigned</span>;
	}

	return (
		<>
			<span className={styles.driver}>{`${assigned.driver.name} (${assigned.driver.id})`}</span>
			{!disableVehicleInfo && 'tractors' in assigned.driver && (
				<>
					<Chip
						className={styles.tractor}
						color='secondary'
						label={
							<>
								<LocalShippingIcon fontSize='inherit' />
								{assigned.tractorId ? assigned.tractorId : 'No Truck Assigned'}
							</>
						}
					/>
				</>
			)}
		</>
	);
}
